module.exports = __webpack_public_path__ + "img/reeducation@2x.779e4cc6.png";